// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"538":"recorder","983":"profiler"}[chunkId] + "." + {"538":"2c7498e00727e8f7","983":"f141aeb4398e5474"}[chunkId] + ".js";
};